import loaderGif from "../../assets/imgs/_loader.gif";

export const StartOverlay = ({ text = "Attendere..." }) => {
    return (
        <div id="start-overlay">
            <img className="start-overlay__spinner" src={loaderGif} alt="" />
            <span className="start-overlay__text">{text}</span>
        </div>
    );
};
